import { MSALV2Client } from '@employee-experience/core/lib/MSALV2Client';
import { Shell } from '@employee-experience/shell';
import { withStore } from '@employee-experience/shell/lib/withStore';
import { StoreBuilder } from '@employee-experience/shell/lib/StoreBuilder';
import { ReducerRegistry } from '@employee-experience/shell/lib/ReducerRegistry';

import persistStorage from 'redux-persist/es/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { IHttpClientRequest, IHttpClientOption } from '@employee-experience/common/lib/Models';
import { ComponentLoader, GraphClient, HttpClient, TelemetryClient } from '@employee-experience/core';

/*eslint no-warning-comments: [2, { "terms": ["todo", "fixme", "any other term"], "location": "anywhere" }]*/
const telemetryClient = new TelemetryClient({
    instrumentationKey: __INSTRUMENTATION_KEY__,
    defaultProperties: {
        appName: __APP_NAME__
    }
});

const authClient = new MSALV2Client(
    {
        auth: {
            clientId: __CLIENT_ID__,
            redirectUri: window.location.origin,
            authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47'
        },
        cache: {
            cacheLocation: 'localStorage', // Storing tokens in localStorage for persistence across sessions
            storeAuthStateInCookie: false // If set to true, MSAL will use cookies for storing authentication state in some scenarios
        }
    },
    telemetryClient
);

const httpClient = new HttpClient(telemetryClient, authClient, {
    logPayload: true
});
const graphClient = new GraphClient(httpClient);
const componentLoader = new ComponentLoader(telemetryClient, httpClient);

//TODO: Waiting for EE team to update their packages
//Two overriding ways, waiting for the team to update and choose one occordingly
// httpClient['getPayloadTelemetryPropery'] = function getPayloadTelemetryPropery(
//     shouldLogPayload = false,
//     payload: {}
// ): {} {
//     return shouldLogPayload ? payload : {};
// };

// httpClient['getPayloadTelemetryPropery'] = function getPayloadTelemetryPropery(
//     shouldLogPayload = true,
//     payload: { requestId: string }
// ): {} {
//     const requestId = payload.requestId;
//     //delete payload.requestId;
//     return {
//         requestId: requestId,
//         payload: payload
//     };
// };

// override default request to pass in custom headers
const request = httpClient.request;
httpClient.request = function<IHttpClientResult>(
    _request: IHttpClientRequest,
    options?: IHttpClientOption
): Promise<IHttpClientResult> {
    //TODO: Waiting for EE team to update their packages
    // const requestId = guid();
    _request = _request || {};
    _request.headers = _request.headers || {};
    // _request.data = _request.data || {};

    // _request.data.requestId = requestId;

    // _request.headers.RequestId = requestId;
    if (!_request.headers['X-Content-Type-Options']) {
        _request.headers['X-Content-Type-Options'] = 'nosniff';
    }

    if (!_request.resource) {
        _request.resource = __CLIENT_ID__;
    }

    return request.call<HttpClient, [IHttpClientRequest, IHttpClientOption | undefined], Promise<T>>(
        httpClient,
        _request,
        options
    );
};

const reducerRegistry = new ReducerRegistry();
const storeResult = new StoreBuilder(reducerRegistry, {})
    .configureSaga({ telemetryClient, authClient, httpClient, componentLoader, graphClient })
    .configurePersistor({
        key: 'root',
        storage: persistStorage,
        stateReconciler: autoMergeLevel2,
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        timeout: null,
        blacklist: ['dynamic']
    })
    .build();

export const ShellWithStore = withStore(storeResult)(Shell);
